import React from "react"
import moment from "moment"
import {DatePicker} from "antd"
import {Icon} from "components/Icon"
import cx from "classnames"
import styles from "./BaseDatePicker.module.css"
import {useModel} from "hooks"

type DatePickerComponentsProps = {[key in string]: any}

export type BaseDatePickerProps = DatePickerComponentsProps & {
    value?: any
    onChange?: (value: any, text: string) => void
    className?: string
    placeholder?: string
    format?: string
    disabled?: boolean
    readOnly?: boolean
    allowClear?: boolean
    error?: boolean
    isUtcDate?: boolean
    suffixIcon?: JSX.Element
    timezone?: string
    disabledDate?: (currentDate: any) => boolean
}

export function BaseDatePicker(props: BaseDatePickerProps) {
    const model = useModel()
    const {
        onChange,
        className,
        format,
        placeholder,
        error,
        readOnly,
        disabled,
        allowClear,
        isUtcDate = false,
        timezone,
        value,
        ...rest
    } = props
    const currentUserDateFormat = model && model.getUserDateFormat && model.getUserDateFormat()

    return (
        <DatePicker
            onChange={(value, dateString) => {
                if (isUtcDate && value) {
                    onChange(moment.utc(value.format("YYYY-MM-DD")), dateString)
                } else if (timezone) {
                    const data = moment(value).clone().tz(timezone).startOf("day").toISOString()
                    onChange(data, dateString)
                } else {
                    onChange(value, dateString)
                }
            }}
            className={cx(styles.datePicker, className, {
                [styles.error]: error,
                [styles.disabled]: disabled,
                [styles.readOnly]: readOnly
            })}
            suffixIcon={
                <div className={styles.calendarIconWrap}>
                    <Icon icon="CALENDAR_INPUT" color="#fff" />
                </div>
            }
            allowClear={allowClear}
            placeholder={placeholder || currentUserDateFormat || "MM/DD/YYYY"}
            format={format || currentUserDateFormat || "MM/DD/YYYY"}
            disabled={disabled || readOnly}
            value={isUtcDate && value ? moment.utc(value) : value}
            {...rest}
        />
    )
}

BaseDatePicker.defaultProps = {
    suffixIcon: (
        <div className={styles.calendarIconWrap}>
            <Icon icon="CALENDAR_INPUT" color="#fff" />
        </div>
    )
}
